export enum MEDALS {
  gold = '🥇',
  silver = '🥈',
  bronze = '🥉',
}
